import { DocumentsStore } from '.';
import { RootState } from '../..';

export const selectDocuments = (state: RootState): DocumentsStore => state.documents;
